import { Capacitor } from '@capacitor/core';

/**
 * Platform detection utilities for Capacitor native vs. web browser.
 */

/** True when running inside a native iOS/Android Capacitor shell */
export const isNative = Capacitor.isNativePlatform();

/** True when running on iOS (native) */
export const isIOS = Capacitor.getPlatform() === 'ios';

/** True when running on Android (native) */
export const isAndroid = Capacitor.getPlatform() === 'android';

/** True when running in a web browser (not Capacitor) */
export const isWeb = Capacitor.getPlatform() === 'web';

/**
 * Returns the current platform string: 'ios' | 'android' | 'web'
 */
export const platform = Capacitor.getPlatform();
